import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

// Send metrics to analytics
const sendToAnalytics = (metric: any) => {
    // Send to Google Analytics
    if (window.gtag) {
        window.gtag('event', 'web_vitals', {
            event_category: 'Performance',
            event_label: metric.name,
            value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
            non_interaction: true,
        });
    }

    // Console log for development
    if (process.env.NODE_ENV === 'development') {
        console.log('Web Vital:', metric);
    }

    // Send to your analytics endpoint (optional)
    // fetch('/api/analytics/vitals', {
    //   method: 'POST',
    //   body: JSON.stringify(metric),
    //   headers: { 'Content-Type': 'application/json' }
    // });
};

// Initialize Web Vitals tracking
export const initWebVitals = () => {
    getCLS(sendToAnalytics);  // Cumulative Layout Shift
    getFID(sendToAnalytics);  // First Input Delay  
    getFCP(sendToAnalytics);  // First Contentful Paint
    getLCP(sendToAnalytics);  // Largest Contentful Paint
    getTTFB(sendToAnalytics); // Time to First Byte
};

// Performance monitoring utilities
export const trackPageLoad = () => {
    if (typeof window !== 'undefined' && window.performance) {
        window.addEventListener('load', () => {
            setTimeout(() => {
                const perfData = window.performance.timing;
                const pageLoadTime = perfData.loadEventEnd - perfData.navigationStart;

                if (window.gtag) {
                    window.gtag('event', 'page_load_time', {
                        event_category: 'Performance',
                        value: pageLoadTime,
                        non_interaction: true
                    });
                }
            }, 0);
        });
    }
};

// Track Core Web Vitals score
export const calculatePerformanceScore = (metrics: any[]) => {
    const thresholds = {
        LCP: { good: 2500, poor: 4000 },
        FID: { good: 100, poor: 300 },
        CLS: { good: 0.1, poor: 0.25 },
        FCP: { good: 1800, poor: 3000 },
        TTFB: { good: 800, poor: 1800 }
    };

    let score = 0;
    let totalMetrics = 0;

    metrics.forEach(metric => {
        const threshold = thresholds[metric.name as keyof typeof thresholds];
        if (threshold) {
            totalMetrics++;
            if (metric.value <= threshold.good) {
                score += 100;
            } else if (metric.value <= threshold.poor) {
                score += 50;
            }
        }
    });

    return totalMetrics > 0 ? score / totalMetrics : 0;
}; 